<script setup lang="ts">
// menu já filtrado pelas flags (paridade com o menu antigo)
const { menu } = useUserV2Menu();

// Tela raiz da tab "Dados" no mobile (Figma 19771:41990): título
// "Edite seus dados" + lista de opções (USER_V2_MENU). No desktop essa tela
// não existe — a sidebar do Shell cumpre o papel —, então a lista fica
// md:hidden e mostramos só um hint de navegação.
const route = useRoute();
const { state, getScreenForPath } = useUserV2Modal();

const expandedMenus = ref<Set<string>>(new Set());

function toggleMenu(label: string) {
  if (expandedMenus.value.has(label)) {
    expandedMenus.value.delete(label);
  } else {
    expandedMenus.value.add(label);
  }
  // reatribui pra disparar reatividade do Set
  expandedMenus.value = new Set(expandedMenus.value);
}

// mesma lógica de Shell.vue (isMenuActive) — resolve pra tela em vez de
// comparar só o path: "Limites de proteção" e "Auto-Exclusão" dividem o
// mesmo path (/user/account-protection) com ?section= diferente.
function isMenuActive(to?: string) {
  if (!to) return false;

  const screen = getScreenForPath(to);

  if (screen) {
    return state.value.screen === screen;
  }

  return route.path.endsWith(to.replace(/\?.*$/, ''));
}
</script>

<template>
  <!-- Mobile: menu "Edite seus dados"; botão "Sair da conta" já vem do Shell.
       Dois gaps diferentes no Figma (19771:41990): 12px do título pra lista,
       6px entre os itens — por isso a lista tem seu próprio flex-col. -->
  <div class="flex flex-col gap-[12px] md:hidden">
    <p class="text-[12px] font-medium leading-[16px] text-white">
      Edite seus dados
    </p>

    <div class="flex flex-col gap-[6px]">
      <template
        v-for="entry in menu"
        :key="entry.label"
      >
        <UserV2MenuItem
          :active="!entry.children && isMenuActive(entry.to)"
          :coming-soon="entry.comingSoon"
          :expandable="!!entry.children"
          :expanded="expandedMenus.has(entry.label)"
          :icon="entry.icon"
          :label="entry.label"
          :to="entry.to"
          @click="entry.children && !entry.to && toggleMenu(entry.label)"
          @toggle="toggleMenu(entry.label)"
        />
        <template v-if="entry.children && expandedMenus.has(entry.label)">
          <UserV2MenuItem
            v-for="child in entry.children"
            :key="child.label"
            :active="isMenuActive(child.to)"
            :icon="child.icon"
            :label="child.label"
            nested
            :to="child.to"
          />
        </template>
      </template>
    </div>
  </div>

  <!-- Desktop: sem frame equivalente no Figma (a sidebar do Shell já lista
         as opções); mostra apenas um hint em vez de redirecionar. -->
  <div
    class="border-solid hidden min-h-[200px] items-center justify-center rounded-[16px] border border-v2-default/40 p-[16px] text-[14px] leading-[20px] text-white/60 md:flex"
  >
    Selecione uma opção no menu ao lado para editar seus dados.
  </div>
</template>
